// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const CodeOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"currentColor","viewBox":"0 0 16 16","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M5.85 4.85a.5.5 0 10-.7-.7l-3.5 3.5a.5.5 0 000 .7l3.5 3.5a.5.5 0 00.7-.7L2.71 8l3.14-3.15zm4.3 0a.5.5 0 01.7-.7l3.5 3.5a.5.5 0 010 .7l-3.5 3.5a.5.5 0 01-.7-.7L13.29 8l-3.14-3.15z"}}]},"name":"code","theme":"outlined"};

const CodeOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={CodeOutlinedSvg} />;
  CodeOutlined.displayName = 'CodeOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(CodeOutlined);
